(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(dots){
    var row=document.getElementById(dots.dataset.grid);
    if(!row||dots.dataset.ready)return;
    dots.dataset.ready='1';
    var pages=0,step=0;
    function build(){
      dots.innerHTML='';pages=0;
      if(window.innerWidth>767)return;
      var items=row.querySelectorAll(':scope > .columns');
      if(!items.length)return;
      var w=items[0].offsetWidth;if(!w)return;
      var vis=Math.max(1,Math.round(row.clientWidth/w));
      pages=Math.ceil(items.length/vis);step=vis*w;
      if(pages<2){pages=0;return;}
      for(var i=0;i<pages;i++){(function(n){var s=document.createElement('span');s.addEventListener('click',function(){row.scrollTo({left:n*step,behavior:'smooth'});});dots.appendChild(s);})(i);}
      update();
    }
    function update(){
      if(!pages)return;
      var max=row.scrollWidth-row.clientWidth;
      var idx=row.scrollLeft>=max-4?pages-1:Math.round(row.scrollLeft/step);
      var d=dots.children;for(var i=0;i<d.length;i++){d[i].classList.toggle('is-active',i===idx);}
    }
    row.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',build);
    build();
  }
  function init(){document.querySelectorAll('.be-swipe-dots').forEach(setup);}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
